import type { ReactNode } from 'react';

export function BadgeOverlayContainer({ children }: { children: ReactNode }) {
  return (
    <div className="absolute top-3 left-3 z-20 flex max-w-[80%] items-center gap-2">
      {children}
    </div>
  );
}
